import React from 'react';
import styled, { css } from 'styled-components';
import { mediaBreakpointUp } from '@whitelabel/helpers/style/grid';
import { spacer, multiply } from '@whitelabel/helpers/style/units';
import StyledPolicyIconBase from '../../styled/StyledPolicyIcon';

export const StyledPolicyHeading = styled.h2`
  display: flex;
  align-items: center;
  text-align: center;
`;

// Disable eslint to keep the original logic: not pass no-unused-vars
// props down to child component.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const StyledPolicyIcon = styled(({ showDisclaimer, ...props }) => <StyledPolicyIconBase {...props} />)`
  max-width: ${multiply(spacer, 2)};
  max-height: ${multiply(spacer, 2)};
  margin-bottom: ${multiply(spacer, 0.5)};

  ${mediaBreakpointUp('md')`
    max-width: ${multiply(spacer, 3)};
    max-height: ${multiply(spacer, 3)};
    margin-inline-end: ${spacer};
  `}

  ${({ showDisclaimer }: { showDisclaimer: boolean }) =>
    showDisclaimer &&
    css`
      margin-top: -${spacer};
    `}
`;
